// blakfy-cookie/src/i18n/translations/ur.js — Urdu translations

export default {
  title: "کوکی ترجیحات",
  intro:
    "یہ سائٹ آپ کے تجربے کو بہتر بنانے کے لیے کوکیز استعمال کرتی ہے۔ تفصیلات کے لیے ہماری کوکی پالیسی دیکھیں۔",
  policyLink: "کوکی پالیسی",
  acceptAll: "سب قبول کریں",
  rejectAll: "سب مسترد کریں",
  preferences: "ترجیحات",
  save: "انتخاب محفوظ کریں",
  close: "بند کریں",
  cat: {
    essential: {
      title: "ضروری کوکیز",
      desc: "سائٹ کے بنیادی افعال کے لیے ضروری ہیں۔ غیر فعال نہیں کی جا سکتیں۔",
      always: "ہمیشہ فعال",
    },
    analytics: {
      title: "تجزیاتی کوکیز",
      desc: "گمنام وزٹ کے اعداد و شمار جمع کرنے کے لیے استعمال ہوتی ہیں۔",
    },
    marketing: {
      title: "مارکیٹنگ کوکیز",
      desc: "ذاتی نوعیت کی اشتہاربازی اور ری ٹارگیٹنگ کے لیے استعمال ہوتی ہیں۔",
    },
    functional: {
      title: "فعلیاتی کوکیز",
      desc: "زبان اور تھیم جیسی ترجیحات یاد رکھنے کے لیے استعمال ہوتی ہیں۔",
    },
  },
  placeholder: {
    title: "مواد بلاک ہے",
    desc: "اس مواد کو دیکھنے کے لیے آپ کو {category} کوکیز کی اجازت دینی ہوگی۔",
    cta: "اجازت دیں",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
